import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { IIndirectTaxGetRegistrationV2Response } from './types';

export function useIndirectTaxRegistration({
  registrationId,
  corporationId,
  includeServiceRequest,
}: {
  registrationId: string;
  corporationId: number;
  includeServiceRequest?: boolean;
}) {
  const query = new URLSearchParams();
  query.append('corporationId', corporationId?.toString());
  if (includeServiceRequest) query.append('includeServiceRequest', 'true');

  const {
    data,
    mutate,
    error,
    isLoading,
  }: {
    data?: IIndirectTaxGetRegistrationV2Response;
    error?: unknown;
    mutate?: KeyedMutator<unknown>;
    isLoading: boolean;
  } = useSWR(
    registrationId
      ? `new-sales-tax/registrations-v2/${registrationId}?${query}`
      : null,
    SWRFetcher({ method: 'GET' }, undefined)
  );

  return {
    data: data?.registration,
    serviceRequest: data?.serviceRequest,
    mutate,
    error,
    isLoading,
  };
}
